import arrayParser from "../arrayParser"

const breastSkinChangesProcessor=(element)=>
{
let assembledElement = ""
let other_abnormality = ""
let abnormalities = []

if (element["Side"] !== "")
    {
    assembledElement += ` ${(element["Side"]).toLowerCase()}`
    }
assembledElement += " breast skin changes which are concerning for breast cancer"

 abnormalities.push(...element["Abnormality"])

 if (element["Other_abnormality"] !== "")
    {
    other_abnormality = element["Other_abnormality"]
    abnormalities.push(other_abnormality)

    }
let parsedAbnormalies = arrayParser(abnormalities)

if (abnormalities.length>0)
    {
    assembledElement += ` including ${parsedAbnormalies}`
    }

if (element["Underlying_lump"] !== "")
    {
    assembledElement += `, ${(element["Underlying_lump" ] === "Yes" ? " with" : " without")} an underlying lump${(element["Present_for_several:"] === "" ? "" : ",")}`
    }

if (element["Present_for_several:"] !== "")
    {
    assembledElement += ` which have been present for several ${element["Present_for_several:"].toLowerCase()}`
    }

return (assembledElement)
}

export default breastSkinChangesProcessor